import { render, staticRenderFns } from "./PlanoAssinatura.vue?vue&type=template&id=b5b4f302&scoped=true"
import script from "./PlanoAssinatura.vue?vue&type=script&lang=js"
export * from "./PlanoAssinatura.vue?vue&type=script&lang=js"
import style0 from "./PlanoAssinatura.vue?vue&type=style&index=0&id=b5b4f302&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b4f302",
  null
  
)

export default component.exports